<template>
    <div class="inline-block relative w-10 h-14">
        <div v-if="isSelected" class="absolute bottom-0 left-0 h-4 w-10">
            <div
                class="w-0 h-0 border-l-[16px] border-r-[16px] border-b-[16px] border-transparent opacity-80"
                :style="{
                    'border-bottom-color': wall.borderColor,
                }"
            ></div>
        </div>
        <div
            class="absolute top-0 -left-2 w-12 h-12 rounded-full border-2 cursor-pointer"
            :style="{
                'background-color': wall.backColor,
                'border-color': wall.border ? wall.borderColor : wall.wallColor,
            }"
        >
            <img
                v-if="testimonial.photo"
                :src="testimonial.photo"
                alt=""
                class="h-full w-full rounded-full object-cover"
            />
            <div
                v-else
                class="h-full w-full rounded-full flex items-center justify-center text-gray-500 dark:text-neutral-200"
            >
                <p v-if="testimonial.name" class="text-base font-semibold">
                    {{ initials }}
                </p>
                <UserSingleIcon v-else class="h-5 w-5" />
            </div>
        </div>
    </div>
</template>

<script>
import { UserSingleIcon } from "@easy/ui/icons";

export default {
    name: "ReviewAvatar",
    props: {
        wall: Object,
        testimonial: Object,
        isSelected: Boolean,
    },
    components: {
        UserSingleIcon,
    },
    computed: {
        initials() {
            return this.testimonial.name
                .split(" ")
                .slice(0, 2)
                .map((n) => n[0]?.toUpperCase())
                .join("");
        },
    },
};
</script>
